import { useCallback } from "react";

interface SelectDisplayProps {
    placeholder: string;
    searchable: boolean;
    isSearching: boolean;
    action: boolean;
    searchValue: string;
    isMulti: boolean;
    checkedOptions: Record<string, unknown>;
    value: string;
    setIsOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
    setSearching: (value: boolean) => void;
    setSearchValue: (value: string) => void;
    error: boolean;
}

const SelectDisplay = ({
    placeholder,
    searchable,
    isSearching,
    action,
    searchValue,
    isMulti,
    checkedOptions,
    value,
    setIsOpen,
    setSearching,
    setSearchValue,
    error,
}: SelectDisplayProps) => {
    const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearching(true);
        setIsOpen(true);
        setSearchValue(e.target.value);
    }, []);

    const handleFocus = useCallback(() => {
        if (!isSearching) {
            setSearching(true);
            setSearchValue("");
        }
    }, [isSearching]);
    return (
        <input
            type="text"
            onChange={searchable ? handleSearch : () => {}}
            value={
                isSearching && searchable && !action
                    ? searchValue
                    : isMulti
                    ? Object.keys(checkedOptions).join(", ")
                    : value && value.charAt(0).toUpperCase() + value.slice(1)
            }
            readOnly={!searchable}
            onClick={() => setIsOpen((prev) => !prev)}
            onFocus={handleFocus}
            onBlur={() => setSearching(false)}
            placeholder={searchable && searchValue === "" && isSearching ? "Search" : placeholder}
            className={error ? 'error' : ''}
        />
    );
};

export default SelectDisplay;
